import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { TabType } from '../types';

import { Tab, Tabs } from '@mui/material';
import Box from '@mui/material/Box';

import { TableCRUDLayoutProps } from 'components/shared/CRUD/TableCRUDLayout';
import UnsavedDataAlert from 'components/shared/CRUD/components/InnerPage/components/UnsavedDataAlert';

import { AccountGroupData } from '../../../../../Procedures/Reports/type';
import TabRenderer from './TabRenderer';

export interface EditPageProps {
  toggleInnerLayout: () => void;
  refreshList: () => void;
  rowData: AccountGroupData;
  rows: TableCRUDLayoutProps<AccountGroupData>['rows'];
}

const EditTabs: React.FC<EditPageProps> = ({
  toggleInnerLayout,
  rowData,
  rows
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'authorizationSettings.edit.sectionTitles'
  });
  const [value, setValue] = useState<TabType>(TabType.GENERAL);

  const [isNavigationDisabled, setIsNavigationDisabled] = useState(false);

  const [currentViewData, setCurrentViewData] = useState(rowData);

  const [isDirty, setIsDirty] = useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setValue(newValue);
  };

  return (
    <Box paddingY={2}>
      <Tabs value={value} onChange={handleChange}>
        {Object.values(TabType).map((tabItem, index) => {
          return (
            <Tab
              key={index}
              value={tabItem}
              label={t(tabItem)}
              disabled={isNavigationDisabled}
              component="a"
            />
          );
        })}
      </Tabs>
      {isDirty && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse'
          }}
        >
          <UnsavedDataAlert />
        </Box>
      )}
      <TabRenderer
        rows={rows}
        currentTab={value}
        toggleInnerLayout={toggleInnerLayout}
        setIsNavigationDisabled={setIsNavigationDisabled}
        currentViewData={currentViewData}
        setCurrentViewData={setCurrentViewData}
        setIsDirty={setIsDirty}
      />
    </Box>
  );
};

export default EditTabs;
